import {Injectable} from '@angular/core';
import {ElectronService} from 'ngx-electron';
import {DeviceDetectorService} from 'ngx-device-detector';
import {LogLevel} from '../data/logLevel';
import {LogSourceType} from '../data/logSourceType';
import {LogSource} from '../data/logSource';
import {LoggerService} from './logger.service';
import packageInfo from '../../../../package.json';
import buildFile from '../../../../buildNumber.json';

@Injectable({
  providedIn: 'root'
})
export class LoggerDeviceService {

  constructor(private loggerService: LoggerService,
              private electronService: ElectronService,
              private deviceService: DeviceDetectorService) {
    this.logDeviceInfo();
    if (this.electronService.isElectronApp) {
      this.electronService.ipcRenderer.on('build-info', (event, arg) => {
        const {version, buildNumber} = arg;
        this.loggerService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.LoggingService, `Electron Version: ${version}#${buildNumber}`);
        this.loggerService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.LoggingService, `Angular Version: ${packageInfo.version}#${buildFile.buildNumber}`);
      });
      this.electronService.ipcRenderer.send('build-info');
    }
  }

  logDeviceInfo() {
    if (this.electronService.isElectronApp) {
      this.loggerService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.LoggingService, 'Running under: Electron');
      if (this.electronService.isLinux) {
        this.loggerService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.LoggingService, 'OS: Linux');
      } else if (this.electronService.isWindows) {
        this.loggerService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.LoggingService, 'OS: Windows');
      } else if (this.electronService.isMacOS) {
        this.loggerService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.LoggingService, 'OS: MacOS');
      }
      if (this.electronService.isX64) {
        this.loggerService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.LoggingService, 'Arch: x64');
      } else if (this.electronService.isX86) {
        this.loggerService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.LoggingService, 'Arch: x86');
      }
    } else {
      this.loggerService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.LoggingService, 'Running under: WebBrowser');
      this.loggerService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.LoggingService, 'Browser: ' + this.deviceService.browser + ' '
        + this.deviceService.browser_version);
      this.loggerService.logMessage(LogLevel.INFO, LogSourceType.SERVICE, LogSource.LoggingService, 'OS: ' + this.deviceService.os + ' ' + this.deviceService.os_version);
    }
  }
}
